import * as mt from "./mutation-types";
import { AnalysesState } from "./types";
import { Analysis, AreaExpansionChartDTO, ScoreAreaComparativeDTO, ComparativeScoreChartDTO, YieldByYearDTO, AnalysisSummaryDTO, AnalysisYieldEvolutionDTO, LastYearYieldDTO, CropsStagesDTO } from "@/api/analyses/types";

interface AnalysesPayload {
  analysis: Analysis;
}

export default {
  [mt.CLEANUP](state: AnalysesState) {
    state.analysesContext = undefined;
    state.status = "";
    state.errorContext = undefined;
  },
  [mt.ANALYSES_REQUEST](state: AnalysesState) {
    state.status = "fetching:anlyses";
  },
  [mt.ANALYSES_REQUEST_SUCCESS](state: AnalysesState, { analysis }: AnalysesPayload) {
    state.analysesContext = analysis;
    state.status = "fetch:anlyses";
  },

  [mt.ANALYSES_REQUEST_ERROR](state: AnalysesState) {
    state.status = "error";
  },
  [mt.CREATE_ANALYSIS_REQUEST](state: AnalysesState) {
    state.createStatus = "submitting:analysis";
  },
  [mt.CREATE_ANALYSIS_SUCCESS](state: AnalysesState) {
    state.createStatus = "fetch:analysis";
  },
  [mt.CREATE_ANALYSIS_FAILURE](state: AnalysesState) {
    state.createStatus = "error:analysis";
  },
  [mt.DELETE_ANALYSIS_FAILURE](state: AnalysesState, { analysis }: AnalysesPayload) {
    state.createStatus = "error:delete";
    state.errorContext = analysis;
  },
  [mt.FETCHING_AREA_EXPANSION_DTO] (state: AnalysesState) {
    state.statusAreaExpansion = "fetching:area-expansion";
  },
  [mt.FETCH_AREA_EXPANSION_DTO_SUCCESS] (state: AnalysesState, dto: AreaExpansionChartDTO[]) {
    state.areaExpansionContext = dto;
    state.statusAreaExpansion = "fetch:area-expansion"
  },
  [mt.FETCH_AREA_EXPANSION_DTO_FAILED] (state: AnalysesState) {
    state.areaExpansionContext = null;
    state.statusAreaExpansion = "fail:area-expansion"
  },

  [mt.FETCHING_YIELD_BY_YEAR_DTO] (state: AnalysesState) {
    state.statusYieldByYear = "fetching:yield-by-year";
  },
  [mt.FETCH_YIELD_BY_YEAR_DTO_SUCCESS] (state: AnalysesState, dto: YieldByYearDTO[]) {
    state.yieldByYearContext = dto;
    state.statusYieldByYear = "fetch:yield-by-year"
  },
  [mt.FETCH_YIELD_BY_YEAR_DTO_FAILED] (state: AnalysesState) {
    state.yieldByYearContext = null;
    state.statusYieldByYear = "fail:yield-by-year"
  },
 
  [mt.FETCH_COMPARATIVE_SCORE_REQUEST] (state: AnalysesState) {
    state.statusComparativeScore = "fetching:comparative-score";
  },
  [mt.FETCH_COMPARATIVE_SCORE_SUCCESS] (state: AnalysesState, dto: ComparativeScoreChartDTO[]) {
    state.comparativeScoreContext = dto;
    state.statusComparativeScore = "fetch:comparative-score"
  },
  [mt.FETCH_COMPARATIVE_SCORE_FAILED] (state: AnalysesState) {
    state.comparativeScoreContext = null;
    state.statusComparativeScore = "fail:comparative-score"
  },

[mt.FETCH_ANALYSIS_SUMMARY_REQUEST] (state: AnalysesState) {
  state.statusAnalysisSummary = "fetching:analysis-summary";
},
[mt.FETCH_ANALYSIS_SUMMARY_SUCCESS] (state: AnalysesState, dto: AnalysisSummaryDTO[]) {
  state.analysisSummaryContext = dto;
  state.statusAnalysisSummary = "fetch:analysis-summary"
},
[mt.FETCH_ANALYSIS_SUMMARY_FAILED] (state: AnalysesState) {
  state.analysisSummaryContext = null;
  state.statusAnalysisSummary = "fail:analysis-summary"
},
[mt.FETCH_ANALYSIS_YIELD_EVOLUTION_REQUEST] (state: AnalysesState) {
  state.statusAnalysisYieldEvolution = "fetching:analysis-yield-evolution";
},

[mt.FETCH_ANALYSIS_YIELD_EVOLUTION_SUCCESS] (state: AnalysesState, dto: AnalysisYieldEvolutionDTO[]) {
  state.analysisYieldEvolutionContext = dto;
  state.statusAnalysisYieldEvolution = "fetch:analysis-yield-evolution"
},

[mt.FETCH_ANALYSIS_YIELD_EVOLUTION_FAILED] (state: AnalysesState) {
  state.analysisYieldEvolutionContext = null;
  state.statusAnalysisYieldEvolution = "fail:analysis-yield-evolution"
},

[mt.FETCH_LAST_YEAR_YIELD_REQUEST] (state: AnalysesState) {
  state.statusLastYearYield = "fetching:last-year-yield-request";
},

[mt.FETCH_LAST_YEAR_YIELD_SUCCESS] (state: AnalysesState, dto: LastYearYieldDTO[]) {
  state.lastYearYieldContext = dto;
  state.statusLastYearYield = "fetch:last-year-yield-request"
},

[mt.FETCH_LAST_YEAR_YIELD_FAILED] (state: AnalysesState) {
  state.lastYearYieldContext = null;
  state.statusLastYearYield = "fail:last-year-yield-request"
},

[mt.FETCH_ANALYSIS_CROPS_STAGES_REQUEST] (state: AnalysesState) {
  state.statusAnalysisCropsStages = "fetching:analysis-crops-stage-request";
},

[mt.FETCH_ANALYSIS_CROPS_STAGES_SUCCESS] (state: AnalysesState, dto: CropsStagesDTO[]) {
  state.analysisCropsStagesContext = dto;
  state.statusAnalysisCropsStages = "fetch:analysis-crops-stage-request"
},

[mt.FETCH_ANALYSIS_CROPS_STAGES_FAILED] (state: AnalysesState) {
  state.analysisCropsStagesContext = null;
  state.statusAnalysisCropsStages = "fail:analysis-crops-stage-request"
},
};

